/**
 * patientPlanRequirement.ts
 *
 * `appointment_types.requiresPatientPlan` is a three-value setting, set in the
 * appointment type admin:
 *   0 = nothing, 1 = a patient, 2 = a patient and one of that patient's plans.
 *
 * Shared by the appointments service (which normalises the API value) and the
 * booking form's Plan field rules, so neither imports from the other.
 */

export type PatientPlanRequirement = 0 | 1 | 2;

/**
 * Normalise the API value. Older responses sent a boolean (the model cast
 * folded 2 into `true`), so true/false still map onto patient / nothing.
 * Anything unrecognised reads as "nothing" — the server remains the authority.
 */
export function toPatientPlanRequirement(raw: unknown): PatientPlanRequirement {
  if (raw === true) return 1;
  if (raw === false || raw == null || raw === '') return 0;
  const n = Number(raw);
  return n === 1 || n === 2 ? n : 0;
}
